import React, {useState, useEffect, FC, useRef} from 'react'

import plusIcon from '../../../_metronic/images/smlplus.svg'
import {
  GET_SALES_CHANNEL_AGENTS_LIST,
  DELETE_USER_AGENT,
  UPDATE_USER_STATUS,
  GET_AGENT_LEADER_LIST_FOR_AGENT,
} from '../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'

import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

import DownloadCsv from '../Download/DownloadCsv'
import moment from 'moment'
import EditAgent from './EditAgent'
import {alert, areYouSurePrompt} from '../../../utils/helper'

import SearchList from '../../sharedComponent/SearchList/SearchList'
import {AGENT_LIST_CONFIGS} from './AgentListUtils'
import Breadcrumbs from '../../sharedComponent/Breadcrumbs/Breadcrumbs'
import {GLOBAL_CONSTANTS} from '../../../utils/GlobalConstants'
import {CreateAgentModel} from '../TeamAdmin/SalesChannels/EditSalesChannel/CreateAgentModel'
import {formatCreateAgentInput} from '../TeamAdmin/SalesChannels/SalesChannelHelpers'
import {DownloadTemplate} from '../../sharedComponent/DownloadTemplate/DownloadTemplate'

const MySwal = withReactContent(Swal)
const fetchPolicy = 'network-only'
const DashboardPage: FC = () => {
  const [agentsListApiResponse, setAgentsListApiResponse] = useState<any>([])

  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)

  const [csv, setCsv] = useState<boolean>(false)
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const [downloadData, setDownloadData] = useState<any>([])
  const csvRef = useRef<any>(null)

  const [agentLeaderOptions, setAgentLeaderOptions] = useState<any>([])
  const [listOptions, setListOptions] = useState<any>({
    perPage: 10,
    page: 1,
    searchText: '',
    orderBy: {
    by: 'createdAt',
    order: 'DESC'
  }
  })
  const [showEditModal, setShowEditModal] = useState<any>({
    show: false,
    id: '',
    agentFirstName: '',
    agentLastName: '',
    agentEmail: '',
    agentStatus: '',
    agentLeaderName: '',
  })

  // For Add Modal
  const openAddModal = (event: any, editValue: any) => {
    setShowCreateAppModal(true)
  }

  const handleAddCloseModal = () => {
    setShowCreateAppModal(false)
  }

  // List API
  const [getSalesChannelAgents, {loading: listLoading, refetch}] = useLazyQuery(
    GET_SALES_CHANNEL_AGENTS_LIST,
    {
      fetchPolicy,
      variables: listOptions,
      onCompleted: (agentData) => {
        setAgentsListApiResponse({
          ...agentData.getSalesChannelAgentsList,
          agents: agentData.getSalesChannelAgentsList.agents.map((agents: any) => ({
            ...agents,
            isDisabled: agents.isDisabled === null ? null : !agents.isDisabled,
          })),
        })
      },
      onError: (err) => console.warn(err),
    }
  )

  useEffect(() => {
    getSalesChannelAgents()
  }, [refetch])

  useEffect(() => {
    getSalesChannelAgents()
  }, [listOptions])

  // Download API  Hit
  const [getSalesChannelAgentsCSVList, {loading: reload}] = useLazyQuery(
    GET_SALES_CHANNEL_AGENTS_LIST,
    {
      fetchPolicy,
      variables: filterTempOptions,
      onCompleted: async (agentData) => {
        const res = await agentData.getSalesChannelAgentsList.agents.map((agent: any) => {
          return {
            ...agent,
            agentCreatedAt: moment.utc(agent.agentCreatedAt).local().format('ll, hh:mm A'),
            agentStatus: agent.agentStatus.charAt(0).toUpperCase() + agent.agentStatus.slice(1),
            isDisabled: agent?.isDisabled ? 'Inactive' : 'Active',
          }
        })
        setDownloadData(res)
      },
      onError: (err) => console.warn(err),
    }
  )

  //For Delete
  const [deleteAgent] = useMutation(DELETE_USER_AGENT, {
    fetchPolicy: 'network-only',
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Agent deleted successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      refetch()
    },
    onError: (err) => alert(err.message, 'error'),
  })

  // List Download
  const csvHeaders = [
    {label: 'Agent First Name', key: 'agentFirstName'},
    {label: 'Agent Last Name', key: 'agentLastName'},
    {label: 'Agent Email ID', key: 'agentEmail'},
    {label: 'Agent Rep Id', key: 'agentRepId'},
    {label: '# Products Assigned', key: 'agentProductsCount'},
    {label: 'Created Date', key: 'agentCreatedAt'},
    {label: 'Agent Status', key: 'agentStatus'},
    {label: 'Active Status', key: 'isDisabled'},
  ]

  useEffect(() => {
    const {page, perPage, ...rest} = listOptions
    setFilterTempOptions(rest)
    setCsv(false)
  }, [])

  const csvDownloadFun = async () => {
    await getSalesChannelAgentsCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  //for edit

  const handleOpenEditModal = (
    id: string,
    agentFirstName: string,
    agentLastName: string,
    agentEmail: string,
    agentStatus: string,
    agentRepId: string
  ) => {
    setShowEditModal({
      show: true,
      id,
      agentFirstName,
      agentLastName,
      agentEmail,
      agentStatus,
      agentRepId,
    })
  }

  const [updateAgentStatus] = useMutation(UPDATE_USER_STATUS, {
    onCompleted: (data) => {
      refetch()
      alert('Agent Status updated successfully', 'success')
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })

  // agent Leader API
  const [getAgentLeaderList] = useLazyQuery(GET_AGENT_LEADER_LIST_FOR_AGENT, {
    onCompleted: (data) => setAgentLeaderOptions(data?.getAgentLeaderListForAgent),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getAgentLeaderList({
      variables: {
        salesChannelId: '',
      },
    })
  }, [])
  //create agent handler

  const handleCreateAgentSubmit = async (
    agentValue: any,
    createAgents: any,
    uploadAgent: any,
    trackId?: string,
    salesChannelId?: string
  ) => {
    let agentArray = await formatCreateAgentInput(agentValue, agentLeaderOptions)
    await uploadAgent({
      variables: {
        isVerified: false,
        // salesChannelId: localStorage.getItem('salesEditId'),
        trackId: trackId,
        userData: agentArray,
      },
    })
    refetch()
  }
  return (
    <>
      <Breadcrumbs title='Agent List' subTitle='Home - Agent List' />
      <SearchList
        isSearchable={true}
        filterOptions={listOptions}
        setFilterOptions={setListOptions}
        apiData={agentsListApiResponse?.agents}
        listCount={agentsListApiResponse?.totalCount}
        listLoading={listLoading}
        listConfigs={AGENT_LIST_CONFIGS}
        isActiveApiFieldName='isDisabled'
        idFieldName='agentId'
        paginatedCount={agentsListApiResponse?.agents?.length}
        toolbar={
          <>
            <div className='m-0'>
              <DownloadCsv
                csvDownloadFun={csvDownloadFun}
                reload={reload}
                csvHeaders={csvHeaders}
                csvRef={csvRef}
                downloadData={downloadData}
                downloadFileName='Agents.csv'
              />

              <DownloadTemplate
                href={process.env.REACT_APP_AGENT_TEMPLATE_DOWNLOAD}
                text='Download Template'
                className='ms-2'
              />

              <button
                className='btn btn-primary fs-6 p-3 w-142px h-43px ms-4'
                type='button'
                onClick={(e) => openAddModal(e, '')}
              >
                <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                <span>Add Agent</span>
              </button>
            </div>

            <CreateAgentModel
              show={showCreateAppModal}
              handleClose={handleAddCloseModal}
              refetchList={refetch}
              agentLeaderList={agentLeaderOptions}
              handleCreateAgentSubmit={handleCreateAgentSubmit}
            />
          </>
        }
        dropdownMenuItems={[
          {
            name: 'Edit',
            callBack: (id: string, _, apiDataValues) => {
              handleOpenEditModal(
                apiDataValues.agentId,
                apiDataValues.agentFirstName,
                apiDataValues.agentLastName,
                apiDataValues.agentEmail,
                apiDataValues.agentStatus.toLowerCase(),
                apiDataValues.agentRepId
              )
            },
          },
          {
            name: 'ACTIVATION',
            callBack: (id: string, _, apiDataValues) => {
              areYouSurePrompt(
                'Are you sure?',
                () =>
                  updateAgentStatus({
                    variables: {
                      userId: apiDataValues.agentUserId,
                      isDisabled: apiDataValues.isDisabled ? true : false,
                    },
                  }),
                () => {},
                'Yes',
                'No'
              )
            },
          },
          {
            name: 'Delete',
            callBack: (id: string, _, apiDataValues) => {
              areYouSurePrompt(
                'Are you sure?',
                () => deleteAgent({variables: {emailId: apiDataValues.agentEmail}}),
                () => {},
                'Yes, delete!',
                'No'
              )
            },
            textColor: 'text-danger',
          },
        ]}
      />

      <EditAgent
        modalConfig={showEditModal}
        setShowEditModal={setShowEditModal}
        getSalesChannelAgents={getSalesChannelAgents}
        agentLeaderList={agentLeaderOptions}
      />
    </>
  )
}

const AgentList: FC = () => <DashboardPage />

export {AgentList}
